/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  Children,
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Calendar, DateLocalizer, momentLocalizer } from "react-big-calendar";
import { usePopperTooltip } from "react-popper-tooltip";

import { Dialog, Tab, Transition } from "@headlessui/react";
import sortBy from "lodash/sortBy";
/* Library support */
import moment from "moment";
import PropTypes from "prop-types";

/* Style */
import { HiChevronLeft } from "components/atoms/Icon/hi/HiChevronLeft";
import { HiChevronRight } from "components/atoms/Icon/hi/HiChevronRight";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-popper-tooltip/dist/styles.css";

import styles from "./Index.module.scss";

const mLocalizer = momentLocalizer(moment);
const removeDuplicateObj = (arr) => {
  return arr.filter(
    (value, index, self) =>
      index ===
      self.findIndex((t) => t.month === value.month && t.year === value.year)
  );
};

export default function CalendarCompliance({
  localizer = mLocalizer,
  data,
  setSelectedMonth,
  ...props
}) {
  const [date, setDate] = useState(
    new Date(props.selectedMonth.year, props.selectedMonth.month, 18)
  );
  const { max, views } = useMemo(
    () => ({
      defaultDate: data[0]?.start || null,
      views: {
        month: true,
      },
    }),
    [data]
  );
  const listMonth = sortBy(
    removeDuplicateObj(
      data.map((item) => ({
        month: item.start.getMonth() + 1,
        year: item.start.getFullYear(),
      }))
    ),
    ["year", "month"]
  );
  /* Custom Calendar */

  const calendarRef = useRef();
  const listRef = useRef();
  const [prevDisabled, setPrevDisabled] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [labelTime, setLabelTime] = useState("");

  const ColoredDateCellWrapper = ({ children }) => {
    return React.cloneElement(Children.only(children), {
      style: {
        ...children.style,
        backgroundColor: "transparent",
      },
    });
  };

  const ColoredEvent = ({ children, event }) => {
    const {
      getArrowProps,
      getTooltipProps,
      setTooltipRef,
      setTriggerRef,
      visible,
    } = usePopperTooltip({
      placement: "auto-start",
    });
    const dataTemp = data.filter((item) =>
      moment(event.start).isSame(item.start, "day")
    );

    return React.cloneElement(
      Children.only(children),
      {
        style: {
          ...children.style,
          margin: "0px 0px",
          backgroundColor: "transparent",
          outline: "none",
          width: "fit-content",
          position: "relative",
          padding: 0,
        },
      },
      <div
        className={" group  top-2 my-1 pl-2 lg:absolute lg:my-0"}
        style={{
          left:
            dataTemp.length > 1
              ? `${dataTemp.findIndex((item) => item.id === event.id) * 25}px`
              : 5,
        }}
      >
        <div className="overflow-hidden overflow-ellipsis">
          <div className=" flex w-fit items-start  text-bbc-gray ">
            <div className="inline-flex">
              <ModalCompliance data={data} event={event}>
                <div
                  className={" mr-2 h-5 w-5 rounded-full"}
                  style={{
                    background: event.color,
                  }}
                  ref={setTriggerRef}
                ></div>
              </ModalCompliance>
            </div>
          </div>
        </div>
        <div className="hidden lg:block">
          {visible && (
            <div
              ref={setTooltipRef}
              {...getTooltipProps({
                className:
                  "tooltip-container relative bg-white !shadow-bbc !border-0 text-bbc-gray w-max max-w-xl !p-8  ",
              })}
            >
              <div
                {...getArrowProps({
                  className: "tooltip-arrow before:!border-0",
                })}
              />
              <div className=" flex items-start p-3  text-bbc-gray">
                <div className="inline-flex">
                  <span
                    className={" mr-2 h-5 w-5 rounded-full"}
                    style={{
                      background: event.color,
                    }}
                  ></span>
                </div>
                <span className={"font-medium"}>{event.title}</span>
              </div>
              <div
                className="paragraph"
                dangerouslySetInnerHTML={{ __html: event.description }}
              ></div>
            </div>
          )}
        </div>
      </div>
    );
  };
  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
      toolbar.onNavigate("prev");
      setSelectedMonth({
        month: toolbar.date.getMonth() + 1,
        year: toolbar.date.getFullYear(),
      });
    };

    const goToNext = () => {
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
      toolbar.onNavigate("next");
      setSelectedMonth({
        month: toolbar.date.getMonth() + 1,
        year: toolbar.date.getFullYear(),
      });
    };

    const label = () => {
      const date = moment(toolbar.date);

      setLabelTime(`${date.format("MMMM")}, ${date.format("YYYY")}`);

      return (
        <span>
          <p className=" text-2xl font-semibold leading-9">
            {date.format("MMMM")}, <span> {date.format("YYYY")}</span>
          </p>
        </span>
      );
    };

    return (
      <div className="invisible  m-auto min-w-[300px] max-w-sm">
        <div id="toolbar" className="flex h-0 justify-between">
          <button
            id="prev-btn"
            className="disabled:grayscale "
            onClick={goToBack}
            disabled={
              toolbar.date.getMonth() + 1 === listMonth[0].month &&
              toolbar.date.getFullYear() === listMonth[0].year
            }
          >
            <HiChevronLeft
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5"
            />
          </button>
          <label id="label-time">{label()}</label>
          <button
            id="next-btn"
            className="disabled:grayscale "
            onClick={goToNext}
            disabled={
              toolbar.date.getMonth() + 1 ===
                listMonth[listMonth.length - 1].month &&
              toolbar.date.getFullYear() ===
                listMonth[listMonth.length - 1].year
            }
          >
            <HiChevronRight
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5"
            />
          </button>
        </div>
      </div>
    );
  };

  /* Handle Event */
  const gotoEvent = (choose) => {
    const indexOfCurrentMonth = listMonth.findIndex(
      (item) =>
        item.month === props.selectedMonth.month &&
        item.year === props.selectedMonth.year
    );

    switch (choose) {
      case "PREV": {
        if (indexOfCurrentMonth > 0) {
          const date = new Date(
            listMonth[indexOfCurrentMonth - 1].year,
            listMonth[indexOfCurrentMonth - 1].month - 1,
            18
          );

          setDate(date);
          setSelectedMonth({
            month: listMonth[indexOfCurrentMonth - 1].month,
            year: listMonth[indexOfCurrentMonth - 1].year,
          });
          setLabelTime(
            `${moment(date).format("MMMM")}, ${moment(date).format("YYYY")}`
          );
        } else {
          const monthNearly = {};

          for (let index = 0; index < listMonth.length; index++) {
            const element = listMonth[index];
            const elementDateParse = new Date(element.year, element.month, 18);
            const selectedDateParse = new Date(
              props.selectedMonth?.year,
              props.selectedMonth?.month,
              18
            );

            if (elementDateParse < selectedDateParse) {
              monthNearly.month = element.month;
              monthNearly.year = element.year;
            }
          }
          if (Object.keys(monthNearly).length > 0) {
            setSelectedMonth({
              month: monthNearly.month,
              year: monthNearly.year,
            });
            const monthNearlyDateParse = new Date(
              monthNearly.year,
              monthNearly.month,
              18
            );

            setLabelTime(
              `${moment(monthNearlyDateParse).format("MMMM")}, ${moment(
                monthNearlyDateParse
              ).format("YYYY")}`
            );
          }
        }
        break;
      }
      case "NEXT": {
        if (
          indexOfCurrentMonth < listMonth.length - 1 &&
          indexOfCurrentMonth >= 0
        ) {
          const date = new Date(
            listMonth[indexOfCurrentMonth + 1].year,
            listMonth[indexOfCurrentMonth + 1].month - 1,
            18
          );

          setDate(date);
          setSelectedMonth({
            month: listMonth[indexOfCurrentMonth + 1].month,
            year: listMonth[indexOfCurrentMonth + 1].year,
          });
          setLabelTime(
            `${moment(date).format("MMMM")}, ${moment(date).format("YYYY")}`
          );
        } else {
          const monthNearly = {};

          for (let index = 0; index < listMonth.length; index++) {
            const element = listMonth[index];
            const elementDateParse = new Date(element.year, element.month, 18);
            const selectedDateParse = new Date(
              props.selectedMonth?.year,
              props.selectedMonth?.month,
              18
            );

            if (elementDateParse > selectedDateParse) {
              monthNearly.month = element.month;
              monthNearly.year = element.year;
              break;
            }
          }
          if (Object.keys(monthNearly).length > 0) {
            setSelectedMonth({
              month: monthNearly.month,
              year: monthNearly.year,
            });
            const monthNearlyDateParse = new Date(
              monthNearly.year,
              monthNearly.month,
              18
            );

            setLabelTime(
              `${moment(monthNearlyDateParse).format("MMMM")}, ${moment(
                monthNearlyDateParse
              ).format("YYYY")}`
            );
          }
        }
        break;
      }

      default:
        break;
    }
  };

  /* Handle Effect */
  useEffect(() => {
    setDate(
      new Date(props.selectedMonth.year, props.selectedMonth.month - 1, 18)
    );
  }, [data, props.selectedMonth]);

  useEffect(() => {
    if (document.getElementById("prev-btn"))
      setPrevDisabled(document.getElementById("prev-btn")?.disabled);
    if (document.getElementById("next-btn"))
      setNextDisabled(document.getElementById("next-btn")?.disabled);
  });

  return (
    <>
      <div className="m-auto  min-w-[300px] max-w-sm pb-10 lg:pb-20">
        <div className="flex justify-between ">
          <button
            className="focus:right-0 focus:outline-none disabled:grayscale"
            disabled={prevDisabled}
            onClick={() => {
              document.getElementById("prev-btn")?.click();
            }}
          >
            <HiChevronLeft
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5"
            />
          </button>
          <span>
            <p className=" text-2xl font-semibold leading-9">{labelTime}</p>
          </span>

          <button
            className="focus:right-0 focus:outline-none disabled:grayscale"
            disabled={nextDisabled}
            onClick={() => {
              document.getElementById("next-btn")?.click();
            }}
          >
            <HiChevronRight
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5"
            />
          </button>
        </div>
      </div>

      <div className="w-full">
        <div className="mb-7 flex flex-col-reverse items-center justify-between lg:flex-row">
          <div className="">
            <label
              id="calendar-btn"
              onClick={() => {
                calendarRef.current.click();
              }}
              className="inline-block min-w-[80px] cursor-pointer rounded-full border border-bbc-brand-500 px-4 py-1 text-center text-sm font-medium leading-6 text-bbc-brand-500"
            >
              Calendar
            </label>
            <label
              id="list-btn"
              onClick={() => {
                listRef.current.click();
              }}
              className="inline-block min-w-[80px] cursor-pointer rounded-full  border border-transparent px-4 py-1 text-center text-sm font-medium leading-6 text-bbc-neutral-800"
            >
              List
            </label>
          </div>
          <button
            className=" mb-6 font-medium text-bbc-neutral-700 focus:right-0 focus:outline-none lg:mb-0"
            onClick={() => {
              setSelectedMonth();
            }}
          >
            Back to Monthly View
          </button>
        </div>
        <div className="flex justify-between">
          <button
            className=" font-medium text-bbc-brand-500 focus:right-0 focus:outline-none"
            onClick={() => {
              gotoEvent("PREV");
            }}
          >
            Previous event
          </button>
          <button
            className=" font-medium text-bbc-brand-500 focus:right-0 focus:outline-none"
            onClick={() => {
              gotoEvent("NEXT");
            }}
          >
            Next Event
          </button>
        </div>
      </div>
      <Tab.Group
        as="div"
        className="mb-10"
        onChange={(selectedIndex) => {
          if (selectedIndex === 0) {
            document
              .getElementById("calendar-btn")
              .classList.remove(
                "border-transparent",
                "text-bbc-neutral-800",
                "rounded-full"
              );
            document
              .getElementById("calendar-btn")
              .classList.add(
                "border-bbc-brand-500",
                "text-bbc-brand-500",
                "rounded-full"
              );
            document
              .getElementById("list-btn")
              .classList.remove(
                "!border-bbc-brand-500",
                "!text-bbc-brand-500",
                "rounded-full"
              );
            setPrevDisabled(document.getElementById("prev-btn")?.disabled);
            setNextDisabled(document.getElementById("next-btn")?.disabled);
          } else {
            document
              .getElementById("calendar-btn")
              .classList.remove(
                "border-bbc-brand-500",
                "text-bbc-brand-500",
                "rounded-full"
              );
            document
              .getElementById("calendar-btn")
              .classList.add(
                "border-transparent",
                "text-bbc-neutral-800",
                "rounded-full"
              );
            document
              .getElementById("list-btn")
              .classList.add(
                "!border-bbc-brand-500",
                "!text-bbc-brand-500",
                "rounded-full"
              );
            setPrevDisabled(true);
            setNextDisabled(true);
          }
        }}
      >
        <Tab.List className="hidden space-x-1 rounded-xl bg-blue-900/20 p-1">
          <Tab key={0}>
            <button
              className="focus:right-0 focus:outline-none"
              ref={calendarRef}
            >
              Calendar
            </button>
          </Tab>
          <Tab key={1}>
            <button className="focus:right-0 focus:outline-none" ref={listRef}>
              List
            </button>
          </Tab>
        </Tab.List>
        <Tab.Panels className="mt-2 ">
          <Tab.Panel
            key={0}
            as="div"
            className="focus:outline-none focus:outline-0 focus:ring-0"
          >
            <div className={styles.calendar}>
              <Calendar
                components={{
                  dateCellWrapper: ColoredDateCellWrapper,
                  eventWrapper: ColoredEvent,
                  toolbar: CustomToolbar,
                }}
                date={new Date(moment(date).format())}
                events={data || []}
                localizer={localizer}
                max={max}
                showMultiDayTimes
                step={30}
                views={views}
                onNavigate={(date) => {
                  setDate(date);
                }}
              />
            </div>
          </Tab.Panel>
          <Tab.Panel
            key={1}
            className="focus:outline-none focus:outline-0 focus:ring-0"
          >
            {data
              .filter(
                (item) =>
                  item.start.getFullYear() === props.selectedMonth.year &&
                  item.start.getMonth() + 1 === props.selectedMonth.month
              )
              .map((item, index) => (
                <div
                  className="mb-4 rounded-lg border bg-white px-6 py-4 last:mb-0"
                  key={index}
                >
                  <div className="mb-2 font-medium">
                    {moment(item.start).format("LL")}
                  </div>
                  <div
                    className="mb-4 inline-block rounded-md py-2 px-6 font-medium text-white"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.title}
                  </div>
                  <div
                    className="paragraph"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></div>
                </div>
              ))}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </>
  );
}
CalendarCompliance.propTypes = {
  localizer: PropTypes.instanceOf(DateLocalizer),
  showDemoLink: PropTypes.bool,
};

const ModalCompliance = ({ data, event, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="focus:right-0 focus:outline-none"
      >
        {children}
      </button>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
          style={{ zIndex: 51 }}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-slate-900 opacity-70" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="my-8 inline-block w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="mt-2">
                  <div className=" flex items-start py-3  text-bbc-gray">
                    <div className="inline-flex">
                      <span
                        className={" mr-2 h-5 w-5 rounded-full"}
                        style={{
                          background: data.find(
                            (item) =>
                              event.title.localeCompare(item.title) === 0
                          ).color,
                        }}
                      ></span>
                    </div>
                    <span className={"font-medium"}>{event.title}</span>
                  </div>
                  <div
                    className="paragraph"
                    dangerouslySetInnerHTML={{ __html: event.description }}
                  ></div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
